import { withInstall } from '@tav-ui/utils/with-install'
import InputNumber from './src/input-number.vue'
const TaInputNumber = withInstall(InputNumber)
export { TaInputNumber }
export default TaInputNumber
export * from './src/types'
